<template>
  <div>
    <ats-web-seamless-footer
      :api-url="apiUrl"
      :api-key="apiKey"
      :tenant-id="tenantId"
      :default-language="defaultLanguage"
      data-test="seamless-footer"
    />
  </div>
</template>

<script lang="ts">
import { useRoute } from "vue-router";
import { ApiKey } from "~~/types";

import { useLanguageStore } from "~/stores/language";

export default {
  setup() {
    const languageStore = useLanguageStore();
    const route = useRoute();
    const config = useRuntimeConfig();

    return {
      languageStore,
      route,
      config,
    };
  },

  computed: {
    apiUrl() {
      return this.config.public.apiUrl;
    },

    apiKey() {
      return this.config.public[ApiKey.AUTOSYNC];
    },

    tenantId() {
      return this.config.public.motocommerce.tenantId;
    },

    defaultLanguage() {
      return this.languageStore.language;
    },
  },
};
</script>
